// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2bcd3526","239":"31f3304b","732":"1f84ef78"}[chunkId] + ".chunk.js";
};